import React from "react";

function BrandLogo({ compact = false, size = "md", gap = null, nameScale = 1, hideIcon = false }) {
  const dims = sizeMap[size] || sizeMap.md;
  const logoSrc = "/logo5.png";
  const resolvedGap = gap ?? dims.gap;

  return (
    <span style={{ ...wrap, gap: compact ? 0 : resolvedGap }}>
      {!hideIcon && (
        <img
          src={logoSrc}
          alt="Matka Kings"
          style={{ ...image, width: dims.icon, height: dims.icon }}
          onError={(event) => {
            event.currentTarget.style.display = "none";
          }}
        />
      )}
      {!compact && (
        <span
          style={{
            ...markWrap,
            width: dims.wordWidth,
            height: dims.wordHeight,
            transform: nameScale !== 1 ? `scale(${nameScale})` : undefined,
            transformOrigin: "left center",
          }}
          aria-label="Matka Kings"
        >
          <span style={textShimmer} aria-hidden="true" />
          <svg viewBox="0 0 470 92" role="img" aria-hidden="true" focusable="false" style={wordSvg}>
            <defs>
              <linearGradient id="mkGoldFill" x1="0" x2="1" y1="0" y2="1">
                <stop offset="0%" stopColor="#fff1b8" />
                <stop offset="38%" stopColor="#f6c94f" />
                <stop offset="100%" stopColor="#a86b08" />
              </linearGradient>
              <linearGradient id="mkRedFill" x1="0" x2="1" y1="0" y2="1">
                <stop offset="0%" stopColor="#ff2a42" />
                <stop offset="44%" stopColor="#b40016" />
                <stop offset="100%" stopColor="#630009" />
              </linearGradient>
              <linearGradient id="mkLineFill" x1="0" x2="1" y1="0" y2="0">
                <stop offset="0%" stopColor="#640714" />
                <stop offset="20%" stopColor="#e5092f" />
                <stop offset="68%" stopColor="#ff395c" />
                <stop offset="100%" stopColor="rgba(255,57,92,0)" />
              </linearGradient>
              <filter id="mkTextGlow" x="-20%" y="-40%" width="140%" height="190%">
                <feDropShadow dx="0" dy="2" stdDeviation="2" floodColor="#7f1d1d" floodOpacity="0.42" />
                <feDropShadow dx="0" dy="0" stdDeviation="2.5" floodColor="#facc15" floodOpacity="0.18" />
              </filter>
            </defs>
            <g filter="url(#mkTextGlow)" transform="skewX(-7)">
              <text x="10" y="55" style={wordText} fill="url(#mkGoldFill)" stroke="#5f3300" strokeWidth="1.6">MATKA</text>
              <text x="164" y="55" style={wordText} fill="url(#mkRedFill)" stroke="#500510" strokeWidth="1.6">KINGS</text>
            </g>
          </svg>
        </span>
      )}
    </span>
  );
}

export default BrandLogo;

const sizeMap = {
  md: { icon: 54, wordWidth: 260, wordHeight: 56, gap: 1 },
  sm: { icon: 40, wordWidth: 198, wordHeight: 44, gap: 1 },
  xs: { icon: 28, wordWidth: 154, wordHeight: 32, gap: 1 },
};

const wrap = {
  display: "inline-flex",
  alignItems: "center",
  minWidth: 0,
  maxWidth: "100%",
};

const image = {
  objectFit: "contain",
  flexShrink: 0,
  background: "transparent",
};

const markWrap = {
  display: "inline-flex",
  position: "relative",
  flexShrink: 1,
  minWidth: 0,
  overflow: "hidden",
};

const textShimmer = {
  position: "absolute",
  top: "9%",
  bottom: "18%",
  width: "42%",
  left: "-52%",
  transform: "skewX(-20deg)",
  background: "linear-gradient(90deg, rgba(255,255,255,0), rgba(255,255,255,.72), rgba(255,255,255,0))",
  mixBlendMode: "screen",
  filter: "blur(.2px)",
  animation: "mkLogoShimmer 5s ease-in-out infinite",
  pointerEvents: "none",
  zIndex: 2,
};

const wordSvg = {
  display: "block",
  width: "100%",
  height: "100%",
  overflow: "visible",
};

const wordText = {
  fontFamily: '"Arial Black", Impact, Haettenschweiler, sans-serif',
  fontSize: 40,
  fontWeight: 900,
  letterSpacing: -0.1,
  paintOrder: "stroke fill",
};
